import React, { useState, useEffect } from 'react';
import { getAuth, confirmPasswordReset, applyActionCode } from "firebase/auth";
import app from './firebase';
import './App.css';

function App() {
  const [view, setView] = useState('selection'); // 'selection', 'verifyEmail', 'resetPassword'
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [oobCode, setOobCode] = useState(null); 
  
  // E-posta doğrulama state'leri
  const [verifyState, setVerifyState] = useState({
    loading: false,
    error: null,
    success: false
  });
 
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setOobCode(queryParams.get('oobCode'));
    const mode = queryParams.get('mode');
    if (mode === 'verifyEmail') {
      setView('verifyEmail');
    } else if (mode === 'resetPassword') {
      setView('resetPassword');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsError(false);
    setMessage('');

    // Basit doğrulama kuralları
    if (password.length < 8) {
      setIsError(true);
      setMessage('Şifre en az 8 karakter olmalıdır.');
      return;
    }

    if (password !== confirmPassword) {
      setIsError(true);
      setMessage('Şifreler birbiriyle eşleşmiyor!');
      return;
    }

    if (!oobCode) {
      setIsError(true);
      setMessage('Şifre sıfırlama kodu (oobCode) bulunamadı. Linkin doğru olduğundan emin olun.');
      return;
    }

    setIsLoading(true);

    try {
      const auth = getAuth(app);
      await confirmPasswordReset(auth, oobCode, password);
      setIsLoading(false);
      setMessage('Şifreniz başarıyla güncellendi!');
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      setMessage('Hata: ' + error.message);
      console.error("Hata:", error);
    }
  };

  const handleVerifyEmail = async () => {
    setVerifyState({ loading: true, error: null, success: false });
    try {
      const auth = getAuth(app);
      await applyActionCode(auth, oobCode);
      setVerifyState({ loading: false, error: null, success: true });
    } catch (error) {
      console.error("Doğrulama hatası:", error);
      let errorMessage = 'Doğrulama işlemi başarısız oldu.';
      if (error.code === 'auth/invalid-action-code') {
        errorMessage = 'Doğrulama kodu geçersiz veya süresi dolmuş.';
      }
      setVerifyState({ loading: false, error: errorMessage, success: false });
    }
  };

  const getPasswordStrength = (pass) => {
    let score = 0;
    if (!pass) return 0;
    if (pass.length >= 8) score += 1;
    if (pass.match(/[A-Z]/) && pass.match(/[a-z]/)) score += 1;
    if (pass.match(/[0-9]/)) score += 1;
    if (pass.match(/[^A-Za-z0-9]/)) score += 1;
    return score;
  };

  const strength = getPasswordStrength(password);

  const requirements = [
    { regex: /.{8,}/, text: "En az 8 karakter" },
    { regex: /[A-Z]/, text: "Büyük harf" },
    { regex: /[a-z]/, text: "Küçük harf" },
    { regex: /[0-9]/, text: "Rakam" },
    { regex: /[^A-Za-z0-9]/, text: "Özel karakter" },
  ]; 

  return (
    <div className="app-container">
      <style>{`
        @keyframes successPop {
          0% { transform: scale(0.3); opacity: 0; }
          60% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        .success-icon {
          animation: successPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        }
      `}</style>
      <div className="reset-card">
        <div className="logo-container">
          <img src="/copilot_ikon.png" alt="Uygulama Logosu" className="app-logo" />
          <h1 className="app-name">Pazaryeri</h1>
        </div>

        {view === 'selection' && (
          <>
            <h2 className="card-subtitle">Lütfen yapmak istediğiniz işlemi seçiniz.</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <button onClick={() => setView('verifyEmail')} className="submit-btn" style={{ backgroundColor: 'white', color: '#108d05', border: '1px solid #108d05' }}>
                Kullanıcı E-posta Doğrulama
              </button>
              <button onClick={() => setView('resetPassword')} className="submit-btn">
                Satıcı Şifre Sıfırlama
              </button>
            </div>
          </>
        )}
 
        {view === 'verifyEmail' && (
          <>
            <h2 className="card-title">E-posta Doğrulama</h2>
            
            {!verifyState.loading && !verifyState.success && !verifyState.error && (
              <>
                <p className="card-subtitle">Hesap güvenliğiniz için lütfen e-posta adresinizi doğrulayın.</p>
                <button onClick={handleVerifyEmail} className="submit-btn">
                  Hesabı Doğrula
                </button>
              </>
            )}

            {verifyState.loading && (
              <div className="message">
                <div className="spinner"></div>
                <p style={{marginTop: '10px', marginBottom: 0}}>İşlem yapılıyor...</p>
              </div>
            )}

            {verifyState.error && (
              <div className="message error">
                {verifyState.error}
              </div>
            )}

            {verifyState.success && (
              <div style={{ textAlign: 'center', padding: '30px 10px' }}>
                <svg className="success-icon" viewBox="0 0 24 24" width="72" height="72" stroke="#108d05" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '20px' }}>
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <h3 style={{ color: '#1a1a1a', fontSize: '1.4rem', marginBottom: '12px', fontWeight: '600' }}>Tebrikler!</h3>
                <p style={{ color: '#555', fontSize: '1rem', lineHeight: '1.6', margin: '0 auto', maxWidth: '350px' }}>
                  E-posta adresiniz başarıyla doğrulandı.<br/><br/>
                  Güvenliğiniz nedeniyle hesabınızdan otomatik olarak çıkış yapılmıştır. Lütfen hesabınıza tekrar giriş yapınız.
                </p>
              </div>
            )}
            
            <button 
              onClick={() => setView('selection')} 
              style={{ marginTop: '20px', background: 'none', border: 'none', color: '#666', cursor: 'pointer', textDecoration: 'underline', width: '100%' }}
            >
              Geri Dön
            </button>
          </>
        )}

        {view === 'resetPassword' && (
          <>
            <h2 className="card-title">Şifre Sıfırlama</h2>
            {(!message || isError) && (
              <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">Yeni Şifre</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className="form-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
                <div className="strength-container">
                  <div className="password-strength-meter">
                    <div className={`strength-bar strength-${strength}`}></div>
                  </div>
                  <span className="strength-label">
                    {['', 'Zayıf', 'Orta', 'İyi', 'Güçlü'][strength]}
                  </span>
                </div>
                <ul className="requirements-list">
                  {requirements.map((req, index) => (
                    <li key={index} className={req.regex.test(password) ? 'valid' : ''}>
                      <span className="icon">
                        {req.regex.test(password) ? (
                          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        ) : (
                          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>
                        )}
                      </span>
                      {req.text}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Şifreyi Onayla</label>
                <div className="password-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    className="form-input"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="••••••"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? <div className="spinner"></div> : 'Şifreyi Güncelle'}
              </button>
            </form>
            )}

            {message && isError && (
              <div className="message error">
                {message}
              </div>
            )}

            {message && !isError && (
              <div style={{ textAlign: 'center', padding: '30px 10px' }}>
                <svg className="success-icon" viewBox="0 0 24 24" width="72" height="72" stroke="#108d05" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '20px' }}>
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <h3 style={{ color: '#1a1a1a', fontSize: '1.4rem', marginBottom: '12px', fontWeight: '600' }}>Tebrikler!</h3>
                <p style={{ color: '#555', fontSize: '1rem', lineHeight: '1.6', margin: '0 auto', maxWidth: '350px' }}>
                  {message}<br/><br/>
                  Artık yeni şifrenizle uygulamaya giriş yapabilirsiniz.
                </p>
              </div>
            )}
            <button 
              onClick={() => setView('selection')} 
              style={{ marginTop: '20px', background: 'none', border: 'none', color: '#666', cursor: 'pointer', textDecoration: 'underline', width: '100%' }}
            >
              Geri Dön
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
